import HttpRequest from '@/utils/request'

const axios = new HttpRequest(process.env.VUE_APP_BASE_URL)
export default axios